module.exports = __webpack_public_path__ + "static/media/image_not_found.fbef03d3.png";